'use client';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

// Mirrors ListingCard: a media block (mobile fixed 335px, desktop 348/360 aspect)
// over a padded body with a title line and one meta line — the real cards render
// title + a single primaryMeta (location) line, not two. Same radius/surface as
// the real card so the swap to real content doesn't jump. Flat by default, same
// as ListingCard — CardGridSkeleton adds the shadow for grid-listing loading states.
export function CardSkeleton() {
  return (
    <Box
      sx={theme => ({
        display: 'flex',
        flexDirection: 'column',
        borderRadius: `${theme.radii.card}px`,
        overflow: 'hidden',
        background: theme.palette.colors.surface.neutral.default,
      })}
    >
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={theme => ({height: 335, [theme.breakpoints.up('md')]: {height: 'auto', aspectRatio: '348 / 360'}})}
      />
      <Box sx={{p: 3, display: 'flex', flexDirection: 'column', gap: 1}}>
        <Skeleton variant="text" animation="wave" width="70%" sx={{fontSize: theme => theme.font.size['body-1']}} />
        <Skeleton variant="text" animation="wave" width="50%" sx={{fontSize: theme => theme.font.size['body-3']}} />
      </Box>
    </Box>
  );
}

CardSkeleton.displayName = 'CardSkeleton';
